import { type Action, createReducer, on } from '@ngrx/store';
import * as PlatformAdminsActions from './platform-admins.actions';
import type { PlatformAdminListItem } from './platform-admins.models';

export const PLATFORM_ADMINS_FEATURE_KEY = 'platformAdmins';

export interface PlatformAdminsState {
  admins: PlatformAdminListItem[];
  loading: boolean; // initial/list fetch in flight
  mutating: boolean; // an add/remove in flight
  error: string | null;
}

export interface PlatformAdminsPartialState {
  readonly [PLATFORM_ADMINS_FEATURE_KEY]: PlatformAdminsState;
}

export const initialPlatformAdminsState: PlatformAdminsState = {
  admins: [],
  loading: false,
  mutating: false,
  error: null,
};

const reducer = createReducer(
  initialPlatformAdminsState,

  on(PlatformAdminsActions.loadAdmins, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(PlatformAdminsActions.loadAdminsSuccess, (state, { admins }) => ({
    ...state,
    admins,
    loading: false,
  })),
  on(PlatformAdminsActions.loadAdminsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(
    PlatformAdminsActions.addAdmin,
    PlatformAdminsActions.removeAdmin,
    (state) => ({ ...state, mutating: true, error: null })
  ),

  // Splice the (possibly reactivated) admin into the list in place — dedupe by
  // id first so a reactivation doesn't create a duplicate row.
  on(PlatformAdminsActions.addAdminSuccess, (state, { admin }) => ({
    ...state,
    admins: [...state.admins.filter((a) => a.id !== admin.id), admin],
    mutating: false,
  })),
  on(PlatformAdminsActions.removeAdminSuccess, (state, { id }) => ({
    ...state,
    admins: state.admins.filter((a) => a.id !== id),
    mutating: false,
  })),
  on(
    PlatformAdminsActions.addAdminFailure,
    PlatformAdminsActions.removeAdminFailure,
    (state, { error }) => ({ ...state, mutating: false, error })
  )
);

export function platformAdminsReducer(
  state: PlatformAdminsState | undefined,
  action: Action
) {
  return reducer(state, action);
}
